const $ = window.jQuery;

function init() {
	events();
}

function events() {
	//var touchStartX, touchStartY, touchEndX, touchEndY;
	let menuHeight = $('.o-mobile-menu .push__level-inner').outerHeight();

	$(window).on('resize', function() {
		menuHeight = $('.o-mobile-menu .push__level-inner').outerHeight();
	});

	$('.menu-toggle--open').on('click', function() {
		$('body').addClass('no-scroll');
		$('body > .push').addClass('push--active');
	});
	$('.menu-toggle--close').on('click', function() {
		$('body').removeClass('no-scroll');
		$('body > .push').removeClass('push--active');
	});

	$('.o-mobile-menu .utility-nav-mobile').after('<ul id="fakeMenu" class="menu__list"></ul>');
	$('.o-mobile-menu .menu-right').each(function() {
		$(this).detach().appendTo('#fakeMenu');
	})

	$('.o-mobile-menu .push__level-inner > .menu__list > .menu-item-has-children > a').on('click', function(event) {
		event.preventDefault(); 
		if ( $(this).parent('.menu-item-has-children').hasClass('menu-open')) {
			if (event.target.classList.contains('encumbered')) { // clicked on the word part of the link - go to page
				const link = $(this).attr('href');
				window.location.href = link;
			}
			else {
				// clicked on arrow - slide up
				$(this).parent('.menu-item-has-children').removeClass('menu-open');
				$(this).parent('.menu-item-has-children').children('.child-level').removeClass('child-open').slideUp(260);
				alterHeight();
			}
		}
		else {
			$(this).parent('.menu-item-has-children').addClass('menu-open');
			$(this).parent('.menu-item-has-children').children('.child-level').addClass('child-open').slideDown(260);
			alterHeight();

		}
		
	});
	$('.o-mobile-menu .push__level-inner > .menu__list > .menu-item-has-children .menu-item-has-children > a').on('click', function(event) {
		event.preventDefault();

		if ( $(this).parent('.menu-item-has-children').hasClass('menu-open')) {
			
			if (event.target.classList.contains('encumbered')) { // clicked on the word part of the link - go to page
				const link = $(this).attr('href');
				window.location.href = link;
			}
			else {
				// clicked on arrow - slide up
				$(this).parent('.menu-item-has-children').removeClass('menu-open');
				$(this).parent('.menu-item-has-children').children('.grand-child-level').removeClass('child-open').slideUp(260);
				alterHeight();
			}
		}
		else {
			$(this).parent('.menu-item-has-children').addClass('menu-open');
			$(this).parent('.menu-item-has-children').children('.grand-child-level').addClass('child-open').slideDown(260);
			alterHeight();
		}
		
	});

	function alterHeight() {
		let newMenuHeight = menuHeight;
		$('.child-open').each(function() {
			newMenuHeight = newMenuHeight + $(this).outerHeight();
		});
		$('.o-mobile-menu .push__level-inner').height(newMenuHeight + 104);
	}
}

export {init as default};
